import styled from "styled-components";
import { Color, ColorDark, Font, breakpoints } from "@/shared/Constants";

export const CompatibilityContainer = styled.div`
  .compatibility-header {
    margin: 25px 0 30px;
    .compatibility-header-title {
      ${Font.clarinVarSub2Regular}
      font-size: 36px;
      line-height: 28px;
      color: ${Color.grey};
      ${breakpoints.phone} {
        font-size: 26px;
      }
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          color: ${ColorDark.textLight};
        }
      }
    }
    .compatibility-header-text {
      ${Font.clarinVarSub2Regular}
      font-size: 21px;
      line-height: 26px;
      color: ${Color.grey};
      margin-top: 15px;
      ${breakpoints.phone} {
        font-size: 17px;
        line-height: 23px;
        margin-top: 10px;
      }
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          color: ${ColorDark.textLight};
        }
      }
    }
  }
  .compatibility-content {
    padding-top: 5px;
  }
  .compatibility-western-separator {
    width: 100%;
    margin-top: 60px;
    padding: 4px 0 16px;
    border-top: 1px solid ${Color.greySeparator};
    border-bottom: 1px solid ${Color.greySeparator};
    margin-bottom: 14px;
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        border-top: 1px solid ${ColorDark.greySeparator};
        border-bottom: 1px solid ${ColorDark.greySeparator};
      }
    }
    .compatibility-western-title {
      ${Font.sansBold}
      font-size: 20px;
      color: ${Color.black000};
      border-top: 1px solid ${Color.greySeparator};
      padding-top: 16px;
      ${breakpoints.phone} {
        font-size: 18px;
      }
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          color: ${ColorDark.textLight};
          border-top: 1px solid ${ColorDark.greySeparator};
        }
      }
    }
  }

  .astrology-description {
    display: none;
  }
`;
